(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/prolongation/views/prolongation.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/prolongation/views/prolongation.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.eurojackpot=_svs.eurojackpot||{};
_svs.eurojackpot.components=_svs.eurojackpot.components||{};
_svs.eurojackpot.components.prolongation=_svs.eurojackpot.components.prolongation||{};
_svs.eurojackpot.components.prolongation.templates=_svs.eurojackpot.components.prolongation.templates||{};
svs.eurojackpot.components.prolongation.templates.prolongation = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"prolongationContentRegion\"></div>\n";
},"useData":true});
Handlebars.partials['svs-eurojackpot-components-prolongation-prolongation'] = svs.eurojackpot.components.prolongation.templates.prolongation;
})(svs, Handlebars);


 })(window);